// extracted by mini-css-extract-plugin
module.exports = {"form-body":"FhhSearch_form-body__5pjlf","search-button":"FhhSearch_search-button__eiTro","search-button--error":"FhhSearch_search-button--error__Jx3z6"};